import {
    Heading,
    VStack,
} from "@chakra-ui/react";
import React from "react";
import SkillsBox from "./SkillsBox";
import SkillsCard from "./SkillsCard";
const Development = () => {
    return (
        <div id="development">
            <Heading size={"md"} className={"mt-6 mb-2"}>
                Development Skills
            </Heading>
            <VStack>
                <SkillsBox id="tools">
                    <SkillsCard
                        title={"Html"}
                        text={
                            "I Know html5 all semantic tag and i know how to use it to improve the site seo"
                        }
                        cat={"MarkUp"}
                        photo={'https://i.ibb.co/g37zHp8/512px-Devicon-html5-plain-svg.png'}
                    />
                    <SkillsCard
                        title={"Css"}
                        text={
                            "I Know Css3. I can design the whole website with only css. without any other css framework"
                        }
                        cat={"Style"}
                        photo={'https://i.ibb.co/4WSh2bq/CSS-3-svg.png'}
                    />
                    <SkillsCard
                        title={"JavaScript"}
                        text={
                            "I Know Vanilla Javascript. i have learned javascript from scratch . and i know all es6 syntax of javascript. "
                        }
                        cat={"Language"}
                        photo={'https://i.ibb.co/1807btj/javascript-logo-1.png'}
                    />
                    <SkillsCard
                        title={"Node Js"}
                        text={
                            "I Know Node Js. Node js is nothing but a javascript run time environment in server side."
                        }
                        cat={"Js RunTime"}
                        photo={'https://i.ibb.co/8BHxcf0/nodejs-logo.png'}
                    />
                    <SkillsCard
                        title={"Sass"}
                        text={
                            "Sass is the most powerful professional grade css extension language in the world."
                        }
                        cat={"Css Lang"}
                        photo={'https://i.ibb.co/1LmyJCW/sass-logo-E41-E7734-A8-seeklogo-com.png'}
                    />
                    <SkillsCard
                        title={"Tailwind Css"}
                        text={
                            "Tailwind CSS is  a utility-first CSS framework for rapidly building custom user interfaces."
                        }
                        cat={"Css Framework"}
                        photo={'https://i.ibb.co/sJfBdgg/tailwind-css-logo-5-AD4175897-seeklogo-com.png'}
                    />
                    <SkillsCard
                        title={"Express Js"}
                        text={
                            "Express is a minimal and flexible Node.js web application framework  "
                        }
                        cat={"Node Framework"}
                        photo={'https://i.ibb.co/3WKnfWN/express.png'}
                    />
                    <SkillsCard
                        title={"React Js"}
                        text={
                            "React JS is a JavaScript library used in web development to build interactive elements on websites.  "
                        }
                        cat={"Js Library"}
                        photo={'https://i.ibb.co/ykFWKhm/react-logo-7-B3-CE81517-seeklogo-com.png'}
                    />
                    <SkillsCard
                        title={"Redux Js"}
                        text={
                            "Redux JS is a JavaScript library used in web development to build interactive elements on websites.  "
                        }
                        cat={"Js Library"}
                        photo={'https://i.ibb.co/1LmyJCW/sass-logo-E41-E7734-A8-seeklogo-com.png'}
                    />
                    <SkillsCard
                        title={"Next Js"}
                        text={
                            "Next JS is a JavaScript library used in web development to build interactive elements on websites.  "
                        }
                        cat={"Js Library"}
                        photo={'https://i.ibb.co/721FyPZ/next-js-logo-7929-BCD36-F-seeklogo-com.png'}
                    />
                    {/* <SkillsCard
              title={"React Router"}
              text={
                "I Know React Router. v6 .React Router keeps ui in sync with the url"
              }
              cat={"React Tool"}
            />
            <SkillsCard
              title={"React Query"}
              text={
                "I Know React Query.  React Query makes fetching,caching,synchronizing and updating server state in in react applications a breeze. "
              }
              cat={"React Tool"}
            />
            <SkillsCard
              title={"React Hook Form"}
              text={
                "React Hook Form is a library that helps you validate forms in React. It is a minimal library without any other dependencies, "
              }
              cat={"React Tool"}
            /> 
            <SkillsCard
              title={"React Firebase Hooks"}
              text={
                "This library explores how React Hooks can work to make integration with Firebase even more straightforward than it already is"
              }
              cat={"React Tool"}
            />*/}
                    <SkillsCard
                        title={"Github"}
                        text={
                            "I Use Github to host my code . GitHub is a code hosting platform for version control and collaboration."
                        }
                        cat={"Code Hosting"}
                        photo={'https://i.ibb.co/yVY94ky/github-170-1175028.webp'}
                    />
                    <SkillsCard
                        title={"MongoDb"}
                        text={
                            "I use Mongodb to Manage my data. MongoDB is an open source NoSQL database management program. "
                        }
                        cat={"Database"}
                        photo={'https://i.ibb.co/RzVps1w/mongodb-logo-4-A71340576-seeklogo-com.png'}
                    />
                    <SkillsCard
                        title={"Firebase"}
                        text={
                            "Firebase provides variety of services .i use firebase to authenticate and host the application"
                        }
                        cat={"Auth/Hosting"}
                        photo={'https://i.ibb.co/5BvwJx5/firebase-logo-402-F407-EE0-seeklogo-com.png'}
                    />
                    <SkillsCard
                        title={"Heroku"}
                        text={
                            "Heroku is a container-based cloud Platform as a Service (PaaS). I use heroku to deploy my backend server."
                        }
                        cat={"Server Hosting"}
                        photo={'https://i.ibb.co/TKGwSs8/heroku-logo-B774-A78667-seeklogo-com.png'}
                    />
                    <SkillsCard
                        title={"Netlify"}
                        text={
                            "Netlify is a container-based cloud Platform as a Service (PaaS). I use netlify to deploy my backend server."
                        }
                        cat={"Server Hosting"}
                        photo={'https://i.ibb.co/9w4bYPZ/netlify-logo-758722-CDF4-seeklogo-com.png'}
                    />
                    <SkillsCard
                        title={"JWT"}
                        text={
                            "JWT, or JSON Web Token used to share security information between two parties — a client and a server. I use JWT to Secure my server api."
                        }
                        cat={"Api Security"}
                        photo={''}
                    />
                    {/* <SkillsCard
              title={"Axios"}
              text={
                "Axios is a promise-based HTTP Client for node. js and the browser, i use axios to perform crud operations from the client side to the server"
              }
              cat={"Server"}
            /> */}
                </SkillsBox>
            </VStack>
        </div>
    );
};

export default Development;
